import logoHorizontal from '../../assets/brand/webtika-logo-horizontal.svg';
import logoMark from '../../assets/brand/webtika-logo-mark.svg';
import { iconCatalog as icons } from './icon-catalog';

// Existing semantic keys all resolve to the original Gestionale asset catalogue.
export const appAssets = {
  brand: { logoHorizontal, logoMark },
  icons: {
    ...icons,
    nav: {
      dashboard: icons.dashboard,
      tasks: icons.taskIcon,
      dealsProposals: icons.dealsProposals,
      dealsActive: icons.dealsActive,
      dealsCompleted: icons.dealsCompleted,
      clients: icons.clients,
      suppliers: icons.suppliers,
      team: icons.team,
      calendar: icons.calendar,
      documents: icons.document,
      accounting: icons.coins,
      expenses: icons.sackDollar,
      users: icons.users,
      settings: icons.settings,
    },
    actions: {
      add: icons.add, upload: icons.upload, preview: icons.preview,
      attached: icons.attached, notes: icons.notes, comment: icons.notes, edit: icons.edit,
      download: icons.download, delete: icons.delete, key: icons.password,
      ownership: icons.ownership, resend: icons.mail, power: icons.powerOff,
      complete: icons.completed, accept: icons.completed, reject: icons.crossCircle, search: icons.search, filters: icons.filter,
      menu: icons.menu, mail: icons.mail, phone: icons.phone, logout: icons.logout,
      theme: icons.settings, reset: icons.reset, save: icons.save,
      close: icons.crossCircle, arrowDown: icons.arrowDown, config: icons.config,
    },
    status: {
      warning: icons.triangleWarning,
      pending: icons.pending, inProgress: icons.inProgress, review: icons.review, approved: icons.completed,
      signed: icons.documentsSigned, completed: icons.completed,
    },
    overview: {
      documentsReview: icons.review, documentsSigned: icons.documentsSigned,
      documentsCompleted: icons.completed, documentsMonth: icons.calendar,
      calendarMeeting: icons.calendar, calendarMeetings: icons.clients,
      calendarCompleted: icons.completed, calendarMonth: icons.calendar,
    },
    metrics: {
      pending: icons.pending, inProgress: icons.inProgress, completed: icons.completed,
      requests: icons.pending, document: icons.document, calendar: icons.calendar,
      currency: icons.usdCircle, expected: icons.calendar, received: icons.usdCircle,
      paid: icons.usdCircle, overdue: icons.review, recurring: icons.inProgress,
      signed: icons.documentsSigned, month: icons.calendar, review: icons.review,
      profit: icons.profit, loss: icons.loss,
    },
  },
  illustrations: {}, avatars: {}, placeholders: {},
};

const iconNamespaces = new Set(['nav', 'actions', 'status', 'overview', 'metrics']);

export function getAssetByKey(srcKey) {
  if (!srcKey || typeof srcKey !== 'string') return null;
  // New code can use the original names directly, e.g. `coins`, `save`, `user`.
  if (Object.hasOwn(icons, srcKey)) return icons[srcKey];
  const segments = srcKey.split('.');
  const path = segments.length === 2 && iconNamespaces.has(segments[0])
    ? ['icons', ...segments] : segments;
  const asset = path.reduce((value, segment) =>
    value && Object.hasOwn(value, segment) ? value[segment] : null, appAssets);
  return typeof asset === 'string' ? asset : null;
}

// Completion is green in every context, while navigation keeps the theme colour.
export function getIconTone(key) {
  const asset = getAssetByKey(key);
  if (asset === icons.completed) return 'success';
  if (key === 'actions.reject' || key === 'icons.actions.reject') return 'danger';
  return undefined;
}
